/** @format */

import {wrapPageElement as wrap} from "./root-wrapper";

// Wraps every page in a component
export const wrapPageElement = wrap;
